import React from "react";
import LoadingIndicator from "react-loading-indicator";

import * as Styled from "./ButtonPrimary.styled";

function ButtonPrimary({ children, isLoading, onClick, disabled = false }) {
  const loaderColor = { red: 255, green: 255, blue: 255, alpha: 1 };

  return (
    <Styled.Button onClick={onClick} disabled={disabled} isLoading={isLoading}>
      {isLoading ? <LoadingIndicator color={loaderColor} /> : children}
    </Styled.Button>
  );
}

export default ButtonPrimary;
